import { fetchWithAuth } from '../utils/fetchWithAuth';

export const quotaService = {
  async count({ serviceDeskId, requestTypeId, signal } = {}) {
    const qs = new URLSearchParams({
      serviceDeskId: String(serviceDeskId),
      requestTypeId: String(requestTypeId),
    }).toString();

    const res = await fetchWithAuth(`quotas/count?${qs}`, { method: 'GET', signal });
    let body = {};
    try { body = await res.json(); } catch (_) {}
    if (!res.ok || body?.success === false) {
      const msg = body?.error || `HTTP ${res.status}`;
      throw new Error(msg);
    }
    return body?.data?.count ?? 0;
  },
  async check({ serviceDeskId, requestTypeId, fields, signal } = {}) {
    const res = await fetchWithAuth('quotas/check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        serviceDeskId,
        requestTypeId,
        fields
      }),
      signal
    });

    let body = {};
    try { body = await res.json(); } catch (_) {}

    if (!res.ok || body?.success === false) {
      const msg = body?.error || `HTTP ${res.status}`;
      throw new Error(msg);
    }

    return body?.data || null;
  }
};


